import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Observable } from "rxjs";
import { catchError } from "rxjs/operators";
import { ConfigService } from "@shared/config";
import handleError from "@shared/libraries/handleError";

@Injectable()
export class HomeService {
    public constructor(
        private http: HttpClient,
        private readonly config: ConfigService,
    ) {}

    public login(idMail: string, idPassword: string): Observable<any> {
        const url: string = `${this.config.get("apiEndPoint")}`;

        return this.http
            .post(`${url}/login`, {
                login: idMail,
                password: idPassword,
            })
            .pipe(catchError(handleError));
    }
}
